import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Alert } from "react-bootstrap";
import { SiMinutemailer } from "react-icons/si";
import { BsFillTelephoneOutboundFill, BsWhatsapp } from "react-icons/bs";
import { RiUserLocationFill, RiMailSendLine } from "react-icons/ri";
import { FaClock, FaFacebookF, FaInstagram, FaYoutube } from "react-icons/fa";
import "./ContactForm.css";
import axios from "axios";
import BASE_URL from "./constant";
const ContactForm = () => {
  const [message, setMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    first: "",
    last: "",
    phone: "",
    email: "",
    description: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);

    const formDataToSend = new FormData(event.target);
    formDataToSend.append("access_key", "7256f4cc-b435-4708-8609-97ec0ab0074d");

    const object = Object.fromEntries(formDataToSend);
    const json = JSON.stringify(object);

    try {
      const res = await axios.post(
        `${BASE_URL}/api/v1/contact`,
        formData
      );

      if (res.data.success) {
        setMessage({
          type: "success",
          text: "✅ Your enquiry has been submitted successfully!"
        });

        setFormData({
          first: "",
          last: "",
          phone: "",
          email: "",
          description: "",
        });
      }
    } catch (error) {
      setMessage({ type: "danger", text: "❌ Network error. Please try again." });
    } finally {
      setSubmitting(false);
      setTimeout(() => setMessage(null), 5000);
    }
  };

  const contactInfo = [
    { icon: SiMinutemailer, text: "Lssftrust@gmail.com", label: "Email Us", link: "mailto:Lssftrust@gmail.com" },
    { icon: BsFillTelephoneOutboundFill, text: "+91-9319965799", label: "Call Us", link: "tel:+919319965799" },
    { icon: BsWhatsapp, text: "+91-9319965799", label: "WhatsApp", link: "https://wa.me/919319965799" },
  ];

  const socialLinks = [
    { icon: FaYoutube, link: "https://youtube.com/@lssftrust", color: "#FF0000", label: "YouTube" },
    { icon: FaFacebookF, link: "https://www.facebook.com/lssftrust", color: "#1877F2", label: "Facebook" },
    { icon: FaInstagram, link: "https://www.instagram.com/lssf_trust", color: "#E4405F", label: "Instagram" },
  ];

  const workingHours = [
    { day: "All Days", hours: "Open 24 Hours" }
  ];

  return (
    <div className="contact-page">
      <Container>
        {/* Header Section */}
        <div className="contact-header">
          <div className="header-badge">
            <RiMailSendLine className="badge-icon" />
            <span>Get in Touch</span>
          </div>
          <h1 className="contact-title">
            We'd Love to <span className="highlight">Hear From You</span>
          </h1>
          <p className="contact-subtitle">
            Have questions? Want to get involved? Reach out to us and we'll respond promptly.
          </p>
          <div className="header-decoration">
            <span className="decoration-line"></span>
            <span className="decoration-diamond">✦</span>
            <span className="decoration-line"></span>
          </div>
        </div>

        <Row className="contact-wrapper">
          {/* Contact Info Section - Left Side */}
          <Col lg={5} md={12} className="contact-info-col">
            <div className="contact-info-card">
              <h2 className="info-title">Contact Information</h2>
              <p className="info-subtitle">
                We're here to help and answer any questions you might have
              </p>

              <div className="info-list">
                {contactInfo.map((info, idx) => (
                  <div key={idx} className="info-item">
                    <div className="info-icon-wrapper">
                      <info.icon className="info-icon-contact" />
                    </div>
                    <div className="info-details">
                      <span className="info-label">{info.label}</span>
                      {info.link ? (
                        <a href={info.link} className="info-text link">
                          {info.text}
                        </a>
                      ) : (
                        <p className="info-text">{info.text}</p>
                      )}
                    </div>
                  </div>
                ))}
                <div className="info-item">
                  <div className="info-icon-wrapper">
                    <RiUserLocationFill className="info-icon-contact" />
                  </div>

                  <div className="info-details">
                    <span className="info-label">Camp Address</span>

                    <p className="info-text">
                      At & P.O. – Lai (North)
                      <br />
                      P.S. – Bihta
                      <br />
                      Patna, Bihar – 801112
                    </p>
                  </div>
                </div>

                <div className="info-item">
                  <div className="info-icon-wrapper">
                    <RiUserLocationFill className="info-icon-contact" />
                  </div>

                  <div className="info-details">
                    <span className="info-label">Work Place</span>

                    <p className="info-text">
                      B-18, 3rd Floor
                      <br />
                      Satija House
                      <br />
                      Mukherjee Nagar
                      <br />
                      Delhi – 110009
                    </p>
                  </div>
                </div>
              </div>

              {/* Working Hours */}
              <div className="working-hours">
                <h3 className="hours-title">
                  <FaClock className="hours-icon" />
                  Working Hours
                </h3>
                <div className="hours-list">
                  {workingHours.map((item, idx) => (
                    <div key={idx} className="hour-item">
                      <span className="hour-day">{item.day}</span>
                      <span className="hour-time">{item.hours}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Social Links */}
              <div className="social-section">
                <h3 className="social-title">Connect With Us</h3>
                <div className="social-links">
                  {socialLinks.map((social, idx) => (
                    <a
                      key={idx}
                      href={social.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="social-link"
                      style={{ backgroundColor: social.color }}
                      aria-label={social.label}
                    >
                      <social.icon />
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </Col>

          {/* Form Section - Right Side */}
          <Col lg={7} md={12} className="form-col">
            <div className="form-card">
              <div className="form-header">
                <h2 className="form-title">Send Us a Message</h2>
                <p className="form-subtitle">
                  Fill out the form below and we'll get back to you as soon as possible
                </p>
              </div>

              <Form onSubmit={onSubmit} className="contact-form">
                <Row>
                  <Col md={6}>
                    <Form.Group className="form-group">
                      <Form.Label>First Name *</Form.Label>
                      <Form.Control
                        type="text"
                        name="first"
                        placeholder="Enter your first name"
                        value={formData.first}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="form-group">
                      <Form.Label>Last Name *</Form.Label>
                      <Form.Control
                        type="text"
                        name="last"
                        placeholder="Enter your last name"
                        value={formData.last}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <Form.Group className="form-group">
                      <Form.Label>Phone Number *</Form.Label>
                      <Form.Control
                        type="tel"
                        name="phone"
                        placeholder="Enter your phone number"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="form-group">
                      <Form.Label>Email Address *</Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        placeholder="Enter your email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Form.Group className="form-group">
                  <Form.Label>Message / Description *</Form.Label>
                  <Form.Control
                    as="textarea"
                    name="description"
                    placeholder="Tell us how we can help you..."
                    value={formData.description}
                    onChange={handleChange}
                    rows={5}
                    required
                  />
                </Form.Group>

                {message && (
                  <Alert variant={message.type} className="message-alert">
                    {message.text}
                  </Alert>
                )}

                <Button
                  type="submit"
                  className="submit-btn"
                  disabled={submitting}
                >
                  {submitting ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2"></span>
                      Sending...
                    </>
                  ) : (
                    <>
                      <RiMailSendLine className="btn-icon" />
                      Send Message
                    </>
                  )}
                </Button>
              </Form>
            </div>
          </Col>
        </Row>

        <div className="map-section">
          <h3 className="map-title">Find Us Here</h3>

          <div className="map-grid">

            {/* Camp Address Map */}
            <div className="map-box mb-5">
              <h4>Camp Address</h4>
              <p>
                At S+PO - Lai (North), P.S. Bihta, Patna, Bihar - 801112
              </p>

              <div className="map-container">
                <iframe
                  title="Camp Address Map"
                  src="https://maps.google.com/maps?q=Lai%20North%20Bihta%20Patna%20Bihar%20801112&z=15&output=embed"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                ></iframe>
              </div>
            </div>

            {/* Work Place Map */}
            <div className="map-box">
              <h4>Work Place</h4>
              <p>
                B-18, 3rd Floor, Satija House, Mukherjee Nagar, Delhi - 110009
              </p>

              <div className="map-container">
                <iframe
                  title="Work Place Map"
                  src="https://maps.google.com/maps?q=Satija%20House%20Mukherjee%20Nagar%20Delhi%20110009&z=15&output=embed"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                ></iframe>
              </div>
            </div>

          </div>
        </div>
      </Container>
    </div>
  );
};

export default ContactForm;